export default function (form) {
  const $form = $(form);
  const $submitButton = $(form).find(":submit");
  const $originalFormBody = $(form).find(".modal-form-content");
  const $successFormBody = $(form).find(".modal-form-success");
  const $failFormBody = $(form).find(".alert-danger");

  return $(form).validate({
    rules: {
      phone: {
        digits: true,
        minlength: 10,
        maxlength: 10,
      },
    },
    errorElement: "div",
    errorClass: "invalid-feedback",
    errorPlacement: function (error, element) {
      error.appendTo(element.parent(".form-group"));
    },
    highlight: function (element) {
      $(element).parent().addClass("invalid");
    },
    unhighlight: function (element) {
      $(element).parent().removeClass("invalid");
    },
    submitHandler: function (form) {
      $.ajax({
        type: "POST",
        url: $form.attr("action"),
        data: $form.serialize(),
        beforeSend: function () {
          $submitButton.attr("disabled", true);
          $submitButton.text($submitButton.data("processing-text"));
          $failFormBody.addClass("d-none");
        },
        complete: function (data) {
          $submitButton.attr("disabled", false);
          $submitButton.text($submitButton.data("original-text"));
          if (data.responseJSON.error || data.status !== 200) {
            $failFormBody
              .removeClass("d-none")
              .text(data.responseJSON.error_message);
          } else {
            _paq.push([
              "trackEvent",
              "Event",
              "Inscription réussie à un événement",
            ]);
            $originalFormBody.addClass("d-none");
            $submitButton.addClass("d-none");
            $successFormBody.removeClass("d-none");
          }
        },
        dataType: "json",
      });
    },
  });
}
